import { createDashboardsRequest } from 'pages/ReportsPage/components/AnalyticsDashboards/createDashboardsRequest';
import { DashboardPaginationMeta } from 'pages/ReportsPage/components/AnalyticsDashboards/overtimeMappers';

interface FetchDashboardPageOptions<TBody, TItem> {
  url: string;
  query?: Record<string, unknown>;
  page: number;
  selectItems: (body: TBody) => TItem[];
}

export async function fetchDashboardPage<
  TBody extends { meta?: DashboardPaginationMeta | null },
  TItem,
>({
  url,
  query,
  page,
  selectItems,
}: FetchDashboardPageOptions<TBody, TItem>): Promise<{
  items: TItem[];
  meta: DashboardPaginationMeta | null;
}> {
  const response = await createDashboardsRequest<TBody>({
    url,
    method: 'GET',
    query: { ...query, page },
  });
  const body = response.data;
  return {
    items: body ? selectItems(body) : [],
    meta: body?.meta ?? null,
  };
}
